import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputText, Button, TextValueAccessor } from '@shui/angular';
import { ShAdditionalEmailsComponent, ShSelectComponent, ShSelectOption } from '@shs-digi-care-monorepo/frontend-lib';
import { createOrderDetailsFormGroup, Distributor, OrderDetailsFormGroup } from '../../models/order-details.model';
import { OneDxMaterialItem } from '../../../shared/models/onedx.model';

@Component({
    selector: 'app-order-details',
    templateUrl: './order-details.component.html',
    imports: [
        TranslateModule,
        ReactiveFormsModule,
        InputText,
        Button,
        TextValueAccessor,
        ShAdditionalEmailsComponent,
        ShSelectComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OrderDetailsForm {
    public showContinue = input<boolean>(true);
    public materials = input<OneDxMaterialItem[]>([]);
    public continue = output<void>();
    public pricingCleared = output<void>();

    public formGroup: FormGroup<OrderDetailsFormGroup> = createOrderDetailsFormGroup();

    protected distributorOptions: ShSelectOption[] = Object.values(Distributor).map((value) => ({
        value,
        label: value
    }));

    protected onDistributorAccountChange(value: boolean): void {
        this.formGroup.controls.isDistributor.setValue(value);
        if (!value) {
            this.formGroup.controls.distributorName.setValue(null);
        }
    }

    protected onCprContractChange(value: boolean): void {
        this.formGroup.controls.isCprContract.setValue(value);
        if (value) {
            this.pricingCleared.emit();
        }
    }

    protected onContinue(): void {
        this.continue.emit();
    }
}
